import { render, staticRenderFns } from "./ReceivedCoupon.vue?vue&type=template&id=ed7bd758"
import script from "./ReceivedCoupon.vue?vue&type=script&lang=js"
export * from "./ReceivedCoupon.vue?vue&type=script&lang=js"
import style0 from "./ReceivedCoupon.vue?vue&type=style&index=0&id=ed7bd758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports